import React, { useCallback } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

// Components
import { Button } from '@beef/ui-kit';

// Constants
import { FAMILY_URL } from '../../constants';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const ButtonBlock = ({ setPopupState, addButtonText, aboutButtonText, isMaximumInvited }) => {
  const history = useHistory();

  const handleAddNumberClick = useCallback(() => setPopupState(true), []);
  const handleManageBcnClick = useCallback(() => history.push(FAMILY_URL), []);

  return (
    <div className={cn('wrapper')}>
      {isMaximumInvited && (
      <div className={cn('add-button')}>
        <Button
          onClick={handleAddNumberClick}
          size="m"
          variant="secondary"
        >
          {addButtonText}
        </Button>
      </div>
      )}
      <Button
        size="m"
        variant="tertiary"
        onClick={handleManageBcnClick}
      >
        {aboutButtonText}
      </Button>
    </div>
  );
};

ButtonBlock.propTypes = {
  setPopupState: PropTypes.func,
  addButtonText: PropTypes.string,
  aboutButtonText: PropTypes.string,
  isMaximumInvited: PropTypes.bool,
};

export { ButtonBlock };
